<template>
    <span>{{ value }}</span>
</template>

<script>
export default {
  name: 'CellRendererRelation',
  computed: {
    value () {
      const { data, relation, valueField, count } = this.params;

      if (!relation) {
          return '';
      }

      let relationship = data[relation];

      // Handle objects
      if (typeof relation === 'object') {
          Object.keys(relation).forEach(function(key){
              let subkey = relation[key];
              let relationshipData = data[key];
              relationship = relationshipData[subkey];
          });
      }

      if (!relationship) {
          if (count) {
              return 0;
          }

          return '';
      }

      if (count) {
          return relationship.length;
      }

      if (!valueField) {
          return '';
      }

      if (Array.isArray(relationship)) {
          const val = relationship.map((item) => {
              return item[valueField];
          });
          return (val.join(', '));
      }

      return relationship[valueField];
    }
  }
}
</script>
